import React, { useEffect, useState, useRef } from 'react';
import { get } from '../../../../util/AcessoApi';
import { useInterval } from '../../../../util/Utilitarios';
import '../css/painel.css';
import moment from 'moment';
import localStorage from 'local-storage';
import { BtnAcao, LinkExclusaoArrayTabela } from '../../../../components/Acoes';
import { BotaoPadrao } from '../../../../components/Botoes';
import { ModalDuasOpcoes } from '../../../../components/Modais';

const Painel = props => {
    const [chamadoAgora, setChamadoAgora] = useState({});
    const [ultimasChamadas, setUltimasChamadas] = useState([]);
    const [horario, setHorario] = useState(moment().format('HH:mm'));
    const [dia, setDia] = useState(moment().format('dddd'));
    const [animate, setAnimate] = useState(false);
    const [audioAllowed, setAudioAllowed] = useState(false);

    const doorbellRef = useRef(new Audio(require('../../../../assets/sounds/doorbell.mp3')));

    useEffect(() => {
        const intervalId = setInterval(() => {
            setHorario(moment().format('HH:mm'));
            setDia(moment().format('dddd'));
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        obterAgendamentos();
    }, []);

    const obterAgendamentos = () => {
        Promise.resolve(get(`/atendimento/painel`, null, null)).then(obj => {
            if (obj?.length > 0) {
                if (obj[0]?.id !== chamadoAgora?.id) {
                    if (audioAllowed)
                        playSound();

                    triggerAnimation();
                }
                setChamadoAgora(obj[0]);
                var countChamadas = obj.length - 1;
                var arrayConcat = countChamadas < 4 ? Array(4 - countChamadas).fill({}) : [];
                setUltimasChamadas([...(obj.filter((x, idx) => idx > 0)), ...arrayConcat]);
            }
        });
    };

    useInterval(() => {
        obterAgendamentos();
    }, 5000);

    const playSound = () => {
        const doorbell = doorbellRef.current;
        doorbell.currentTime = 0;
        // doorbell.muted = true;
        doorbell.play().catch(error => {
            console.error('Erro ao reproduzir o som:', error);
        });
    };

    const triggerAnimation = () => {
        setAnimate(true);
        setTimeout(() => setAnimate(false), 1500);
    };

    return (
        <div className={`container-painel d-flex`}>
            <div className="header-painel">
                <div className='content-center'>
                    <BtnAcao classTooltip={'tooltip-input-modal'} classeContent="ml-1-between" className='mr-2' icone={"icon-Megaphone " + (audioAllowed ? '' : 'strikediag')} action={_ => setAudioAllowed(!audioAllowed)} />
                    <h2 className='mb-0'>{dia}</h2>
                </div>
                <h1>{horario}</h1>
            </div>
            <div className={`current-flex current-patient`}>
                {chamadoAgora?.id ? (
                    <div className={`patient-info ${animate ? 'animate' : ''}`}>
                        <p><strong>Paciente:</strong></p>
                        <p><span className="patient-name">{chamadoAgora.paciente}</span></p>
                        <p><strong>Consultório:</strong></p>
                        <p><span className="patient-name">{chamadoAgora.consultorio}</span></p>
                    </div>
                ) : null}
            </div>
            <div className="called-flex previous-calls mt-4">
                <div className="previous-calls mt-4">
                    <h1 className="h3">Últimas Chamadas</h1>
                    <table className='table-called'>
                        <thead>
                            <tr>
                                <th>Paciente</th>
                                <th>Consultório</th>
                                <th>Horário de Chamada</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ultimasChamadas.map((entry, index) => (
                                <tr key={index}>
                                    <td>{entry?.paciente || '--'}</td>
                                    <td>{entry?.consultorio || '--'}</td>
                                    <td>{entry?.hora_chamada || '--'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="footer-logo">
                <img alt="Logomarca Comego" className="logo-painel" src={require('../../../../assets/img/logo-comego.png')} />
                <img alt="Selecta Sistemas" className="logo-selecta-painel" src={require('../../../../assets/img/image.png')} />
            </div>
        </div>
    );
};

export default Painel;